import * as React from 'react';
import { ClientErrorCodes, ErrorCodes } from '@mentimeter/quiz-types';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';

// TODO: translate
const NO_AVAILABLE_QUIZ_MSG =
  'The quiz is not open. Please wait for the presenter to activate it.';
const GENERAL_MESSAGE =
  'If the problem persists, please try reloading your browser or contact us at [hello@mentimeter.com](mailto:hello@mentimeter.com).';
const MULTIPLE_DEVICES =
  'It looks like you are trying to view this page in more than one window. Please close all other windows with the same quiz and refresh to proceed.';
const RESULTS_FETCH = 'Something went wrong when fetching the quiz results';
const NO_CONNECTION =
  'Connection lost ... If the problem persists after a browser reload, your network might block our Quiz servers. \n Please refer your local IT support to our [network requirements](/requirements) page or contact hello@mentimeter.com';

const CODE_MESSAGE_MAP: Record<string, string> = {
  [ErrorCodes.NO_AVAILABLE_QUIZ]: NO_AVAILABLE_QUIZ_MSG,
  [ClientErrorCodes.MULTIPLE_DEVICES]: MULTIPLE_DEVICES,
  [ClientErrorCodes.RESULTS_FETCH]: RESULTS_FETCH,
  [ClientErrorCodes.NO_CONNECTION]: NO_CONNECTION,
};

export const Error = ({ errorCode }: { errorCode: string }) => {
  const copy = CODE_MESSAGE_MAP[errorCode];

  return (
    <Box maxWidth="600px" alignItems="center">
      {copy && (
        <Text
          textAlign="center"
          color="text"
          fontSize="175"
          fontWeight="semiBold"
        >
          <MarkdownText
            source={copy}
            disableLineBreaks={false}
            allowHyperlinks
          />
        </Text>
      )}
      <Text mt={3} textAlign="center" fontSize="125">
        <MarkdownText
          source={GENERAL_MESSAGE}
          disableLineBreaks={false}
          allowHyperlinks
        />
      </Text>
      {!copy && (
        <Text fontFamily="monospace" textAlign="center" fontSize="125">
          Error code: {errorCode}
        </Text>
      )}
    </Box>
  );
};
